import { render } from "./JapanPage.vue?vue&type=template&id=3475baf4&scoped=true"
import script from "./JapanPage.vue?vue&type=script&lang=js"
export * from "./JapanPage.vue?vue&type=script&lang=js"

import "./JapanPage.vue?vue&type=style&index=0&id=3475baf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3475baf4"]])

export default __exports__